import { AssetType, ProductAssetImageType, ProductAssetVideoType } from '../ProductAssets.types'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'
import Image from '../../Image/Image'

const ProductAssetsFullScreenThumbnailItemImage = ({ image }: { image: ProductAssetImageType }) => (
  <Image src={image.src} alt={image.alt} width={70} height={70} />
)
const ProductAssetsFullScreenThumbnailItemVideo = ({ video }: { video: ProductAssetVideoType }) => (
  <>
    <Image src={video.srcImage} alt={video.alt} width={70} height={70} />
    <Icon iconName={Icons.PLAY} className='thumbnail-icon-play' />
  </>
)

const ProductAssetsFullScreenThumbnails = ({ assets }: { assets: Array<AssetType> }) => (
  <div className='product-assets-fullscreen-thumbnails'>
    <ul className='product-assets-fullscreen-thumbnails-list'>
      {assets.map((asset, i) => (
        <li
          key={asset.id}
          className='product-assets-fullscreen-thumbnails-item'
          data-swiper-slide-id={i}>
          {asset.type === 'image' ? (
            <ProductAssetsFullScreenThumbnailItemImage image={asset} />
          ) : (
            <ProductAssetsFullScreenThumbnailItemVideo video={asset} />
          )}
        </li>
      ))}
    </ul>
  </div>
)

export default ProductAssetsFullScreenThumbnails
